import { registerClass } from '../SatCoreRegistry';

import Auth from '../managers/AuthManager';
import contentManager, { CONTENT_ITEM_TYPES, PLAYER_TYPES } from '../managers/ContentManager';
import userManager from '../managers/UserManager';

export default class ContentService {
  static getContentSessionId = async () => {
    return contentManager.currentflowPaperSessionId;
  }

  static getCurrentContentItemId = () => {
    return contentManager.currentContentItemId;
  }

  static setLessonPlayerShowing = (showing) => {
    contentManager.setLessonPlayerShowing(showing);
  }

  static setSatelliteTabShowing = (showing) => {
    contentManager.setSatelliteTabShowing(showing);
  }

  static setIsTeacherPresenting = (isTeacherPresenting) => {
    contentManager.setIsTeacherPresenting(isTeacherPresenting);
  }

  static getOptionsForFileViewer = async ({
    activity,
    activityId = null,
    activityInstance,
    contentItemId,
    contentMode,
    entityTypeId,
    isFlowpaper = false,
    isTeacher,
    sourceActivityId = null,
    sourceActivityResponseId = null
  } = {}) => {
    const resource = await contentManager.fetchResourceItem(contentItemId);
    let viewUrl = resource.presignedAwsUrl || resource.pageUrl;

    // Microsites must hit redirectToMicrosite with activityId so TextHelp
    // accommodation exclusions (excludeTranslation/Dictionary/Listen) are applied.
    // SCORM already passes activityId from ContentManager; microsites were missing it.
    const isMicrosite = entityTypeId === CONTENT_ITEM_TYPES.MICROSITE_RESOURCE
      || (typeof viewUrl === 'string' && viewUrl.includes('redirectToMicrosite'));

    if (isMicrosite) {
      const resolvedActivityId = activityId
        || activity?.id
        || activityInstance?.activityId
        || activityInstance?.id
        || null;
      const resolvedActivityResponseId = (activityInstance?.activityId && activityInstance?.id)
        ? activityInstance.id
        : null;
      const resourceId = resource.id || contentItemId;

      viewUrl = `${Auth.ecms}/api/redirectToMicrosite?resourceId=${resourceId}&authKey=${Auth.authKey}`;
      if (resolvedActivityId) {
        viewUrl += `&activityId=${resolvedActivityId}`;
      }
      if (resolvedActivityResponseId) {
        viewUrl += `&activityResponseId=${resolvedActivityResponseId}`;
      }
      if (sourceActivityId) {
        viewUrl += `&sourceActivityId=${sourceActivityId}`;
      }
      if (sourceActivityResponseId) {
        viewUrl += `&sourceActivityResponseId=${sourceActivityResponseId}`;
      }
    }

    return {
      contentMode,
      isFlowpaper,
      isTeacher: typeof isTeacher === 'boolean' ? isTeacher : userManager.isTeacher,
      optionContentMode: contentMode,
      playerType: PLAYER_TYPES.FILE_VIEWER,
      viewUrl
    };
  };
}

registerClass('ContentService', ContentService);
